export const ApiEndPoints = {
    base_url: process.env.REACT_APP_APIURL,

    //sign in
    user_signIn: "api/v1.0/users/login",
    user_signIn_OTP: "api/v1.0/users/verify-otp",
    user_switch_tenant: "api/v1.0/tenants/switch-tenant",
    user_forget_password: "api/v1.0/users/forget-password",
    user_reset_password: "api/v1.0/users/reset-password",
    user_change_password: "api/v1.0/users/change-password",

    user_roles: "api/v1.0/users/roles",
    system_user_list: "api/v1.0/users/system-users",
    //user_list: "api/v1.0/users",

    //tenant
    tenant_search: "api/v1.0/tenants",
    tenant_create: "api/v1.0/tenants",
    tenant_update: "api/v1.0/tenants/{id}",
    tenant_get: "api/v1.0/tenants/{id}",
    tenant_add_users: "api/v1.0/tenants/{id}/users",
    tenant_user_list: "api/v1.0/tenants/{id}/users",
    tenant_user_assign_admin: "api/v1.0/tenants/{id}/assign-admin",

    //setups   
    service_types_search: "api/v1.0/jobs/service-types",
    service_types_create: "api/v1.0/jobs/service-types",
    service_types_update: "api/v1.0/jobs/service-types/{id}",

    service_search: "api/v1.0/jobs/services",
    service_create: "api/v1.0/jobs/services",
    service_update: "api/v1.0/jobs/services/{id}",

    //products    
    product_search: "api/v1.0/jobs/products",
    product_create: "api/v1.0/jobs/products",
    product_update: "api/v1.0/jobs/products/{id}",

    //promotions    
    promotion_search: "api/v1.0/jobs/promotions",
    promotion_create: "api/v1.0/jobs/promotions",
    promotion_update: "api/v1.0/jobs/promotions/{id}",

    vehicle_model_import: "api/v1.0/system/vehicle-models-import",
    vehicle_makes_search: "api/v1.0/vehicles/vehicle-makes",
    vehicle_model_search: "api/v1.0/vehicles/vehicle-models",

    tax_search: "api/v1.0/system/taxes",

    //subscriptions   
    subscription_features: "api/v1.0/subcriptions/features",
    subscription_plans: "api/v1.0/subcriptions/plans",
    subscription_plan: "api/v1.0/subcriptions/plans/{id}",
    subscription_plans_create: "api/v1.0/subcriptions/plans",
    subscription_plans_update: "api/v1.0/subcriptions/plans/{id}",

    //Jobs
    job_create: "api/v1.0/jobs",
    job_update: "api/v1.0/jobs/{id}",
    job_select: "api/v1.0/jobs/{id}",
    job_search: "api/v1.0/jobs/",
    job_assign: "api/v1.0/jobs/{id}/assign",

    //customers
    customer_create: "api/v1.0/customers",
    customer_update: "api/v1.0/customers/{id}",
    customer_search: "api/v1.0/customers/",

    //vehicles
    vehicle_create: "api/v1.0/vehicles",
    vehicle_update: "api/v1.0/vehicles/{id}",
    vehicle_search: "api/v1.0/vehicles/",
    vehicle_makes: "api/v1.0/vehicles/vehicle-makes",
    vehicle_models: "api/v1.0/vehicles/vehicle-models",

    //Invoice
    invoice_create: "api/v1.0/jobs/{id}/invoices",
    invoice_View_By_Job: "api/v1.0/jobs/{id}/invoice-view",
    invoice_view: "api/v1.0/invoices/{id}/invoice-view",
    invoice_preview_by_job: "api/v1.0/jobs/{id}/invoice-preview",
    invoice_search: "api/v1.0/invoices",
    invoice_reset: "api/v1.0/invoices/{id}/invoice-reset",

    //dashboard
    dashboard_summary: "api/v1.0/reports/summary",

    //customers
    referrer_create: "api/v1.0/referrers",
    referrer_update: "api/v1.0/referrers/{id}",
    referrer_search: "api/v1.0/referrers/",

}